export const handleFileInput = (_file) => {
  if (_file) {
    var file = _file[0];
    return {
      url: URL.createObjectURL(file),
      object: file,
    };
  }
};

export const subStringTime = (_str) => {
  if (!_str) return null;
  let match = _str.match(/\d.*/);
  return match ? match[0] : "";
};

export const convertToSlug = (_str) => {
  if (!_str) return null;

  // _str = _str.toLowerCase();
  // _str = _str.replace(/[^a-zA-Z ]/g, "");
  // _str = _str.trim();
  // _str = _str.replaceAll(/\s/g, "-");

  return _str.replace(/[^A-Z0-9]+/gi, "-");
};

export const getNextCategories = (_curr, _list) => {
  let newList = [];

  let currIndex = _list.findIndex(
    (item) => item.data.Categoryid === _curr.Categoryid
  );

  if (currIndex < _list.length - 4) {
    newList = _list.slice(currIndex + 1).filter((item, i) => i < 4);
  } else {
    // 4th last item in list
    if (currIndex === _list.length - 4) {
      let list = _list.slice(currIndex + 1);
      newList = [...list, _list[0]];
    }
    // 3rd last item in list
    else if (currIndex === _list.length - 3) {
      let list = _list.slice(currIndex + 1);
      newList = [...list, ..._list.slice(0, 2)];
    }
    // 2nd last item in list
    else if (currIndex === _list.length - 2) {
      newList = [_list[_list.length - 1], ..._list.slice(0, 3)];
    }
    // last item in list
    else if (currIndex === _list.length - 1) {
      newList = _list.slice(0, 4);
    }
  }

  return newList;
};

export const sortSourceList = (_list) => {
  if (!_list) return [];

  return _list.sort((a, b) => Number(b.IsAffliate) - Number(a.IsAffliate));
};
